import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  type MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from '@principle-theorem/ng-auth';
import {
  applicationConfig,
  type Decorator,
  moduleMetadata,
} from '@storybook/angular';
import { StorybookCommonModule } from '../modules/storybook-common';
import { decorateAngularFire } from './angularfire-decorator';
import { of } from 'rxjs';
import { STANDALONE_COMPONENT_TEST_PROVIDERS } from '../../testing/standalone-component-test';

function initializeMaterialSymbols(iconRegistry: MatIconRegistry): () => void {
  return () => {
    iconRegistry.registerFontClassAlias(
      'material-symbols',
      'material-symbols-outlined'
    );
  };
}

export function decorateStorybookCommon(): Decorator[] {
  return [
    decorateAngularFire(),
    moduleMetadata({
      imports: [StorybookCommonModule],
    }),
    applicationConfig({
      providers: [
        importProvidersFrom(BrowserAnimationsModule),
        ...STANDALONE_COMPONENT_TEST_PROVIDERS,
        {
          provide: APP_INITIALIZER,
          useFactory: initializeMaterialSymbols,
          deps: [MatIconRegistry],
          multi: true,
        },
        {
          provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
          useValue: {
            appearance: 'outline',
            floatLabel: 'auto',
          } as MatFormFieldDefaultOptions,
        },
        {
          provide: AuthService,
          useValue: {
            authUser$: of(undefined),
            authToken$: of(undefined),
            claims$: of(undefined),
            sendPassowrdlessLoginLink: () => Promise.resolve(),
            linkToExistingAccount: () => Promise.resolve(),
            reauthenticate: () => Promise.resolve(),
            checkWorkspaceAccess: () => Promise.resolve(),
            updateClaims: () => Promise.resolve(),
            logout: () => Promise.resolve(),
            applyActionCode: () => Promise.resolve(),
            checkActionCode: () => Promise.resolve(),
            verifyPasswordCode: () => Promise.resolve(),
            confirmPasswordReset: () => Promise.resolve(),
            signIn: () => Promise.resolve(),
            isSignInLink: () => false,
            signInWithEmailLink: () => Promise.resolve(),
            getSignInMethods: () => Promise.resolve([]),
            signInWithGoogleProvider: () => Promise.resolve(),
            loadClaims: () => Promise.resolve(),
          },
        },
      ],
    }),
  ];
}
